// must be first
import 'dummen-shared/polyfills';

import './toastification-override.scss';

import {vTooltip} from 'floating-vue';
import {createPinia} from 'pinia';
import * as Sentry from '@sentry/vue';
import {createApp} from 'vue';
import {createI18n} from 'vue-i18n';
import App from './App.vue';
import Toast, {type PluginOptions} from 'vue-toastification';

const messages = {
	en: {
		...window.shoppingcartTranslations,
		...window.syngentaTranslations,
	}
};

const i18n = createI18n({legacy: false, locale: 'en', messages: messages});
const app = createApp(App);

const options: PluginOptions = {
	containerClassName: 'dummen-toast-container',
	icon: false,
	hideProgressBar: true
};

const sentry = window.sentrySettings;

if (sentry?.dsn) {
	Sentry.init({
		app,
		dsn: sentry.shoppingCartDsn,
		environment: sentry.environment,
		release: sentry.release,
		integrations: [
			Sentry.browserTracingIntegration(),
		],
		tracesSampleRate: 0.5,
	});
}

app.use(createPinia());
app.use(i18n);
app.use(Toast, options);
app.directive('tooltip', vTooltip);

app.mount('#vue-shoppingcart');
